var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pro_tree"
  }, _vm._l(_vm.data, function (node) {
    return _c('ProTreeNode', _vm._g(_vm._b({
      key: node.id,
      attrs: {
        "node": node,
        "depth": 0,
        "favoriteUnitIds": _vm.favoriteUnitIds
      }
    }, 'ProTreeNode', _vm.$attrs, false), _vm.$listeners));
  }), 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };